import React, { useState } from 'react';
import { Typography } from 'antd';
import { Button, notification } from '@gamesb42/ui-kit';
import { useHistory } from 'react-router-dom';

import { resendConfirmCode } from 'api/users';
import urls from 'constants/urls';

const { Title, Text, Link } = Typography;

interface InvalidCodeScreenProps {
  code: string;
}

const InvalidCodeScreen: React.FC<InvalidCodeScreenProps> = ({ code }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [resent, setResent] = useState(false);

  const handleResend = async () => {
    setLoading(true);
    try {
      await resendConfirmCode({ code });
      setResent(true);
    } catch (error) {
      console.error('Resend invite error:', error);
      notification.error({
        theme: 'dark',
        message: 'Failed to Resend Invite',
        description: 'Could not resend the invitation. Please contact your administrator.',
        placement: 'bottomLeft',
      });
    } finally {
      setLoading(false);
    }
  };

  if (resent) {
    return (
      <div style={{ textAlign: 'left' }}>
        <Title level={2} style={{ marginBottom: '20px', color: '#090909' }}>
          Invitation Sent
        </Title>
        <Text style={{ display: 'block', marginBottom: '32px', color: '#606176', fontSize: '16px' }}>
          A new invitation link has been sent to your email address. Please check your inbox.
        </Text>
        <Link
          onClick={() => history.push(urls.getAuth())}
          style={{ color: '#5227cb', fontSize: '16px', cursor: 'pointer' }}
        >
          Back to Sign In
        </Link>
      </div>
    );
  }

  return (
    <div style={{ textAlign: 'left' }}>
      <Title level={2} style={{ marginBottom: '20px', color: '#090909' }}>
        Invite link expired
      </Title>

      <Text style={{ display: 'block', marginBottom: '32px', color: '#606176', fontSize: '16px' }}>
        For your security, invitation links are only valid for a limited time
      </Text>

      {code && (
        <Button
          type="primary"
          size="large"
          violet
          loading={loading}
          style={{ color: '#fff', width: '154px', marginBottom: '24px' }}
          onClick={handleResend}
        >
          Resend Invite
        </Button>
      )}

      <div>
        <Link
          onClick={() => history.push(urls.getAuth())}
          style={{ color: '#5227cb', fontSize: '16px', cursor: 'pointer' }}
        >
          Back to Sign In
        </Link>
      </div>
    </div>
  );
};

export default InvalidCodeScreen;
